module.exports = __webpack_public_path__ + "img/icon_4_26.ee1c9f9a.png";